import React from 'react';
import { LOCATION_TYPES } from '../constants';

const LocationSection = ({ 
  formData, 
  handleChange, 
  locations, 
  locationsLoading, 
  locationsError, 
  isSubmitting 
}) => {
  return (
    <div>
      <h3 className="text-lg font-semibold text-gray-800 font-poppins mb-4 border-b-2 border-gray-200 pb-2">
        Request Details
      </h3>

      <div className="space-y-4">
        {/* Location Selection */}
        <div className="relative">
          <label htmlFor="locationType" className="block text-sm font-medium text-gray-700 mb-2 font-poppins">
            Location *
          </label>
          <select
            id="locationType"
            name="locationType"
            required
            value={formData.locationType}
            onChange={handleChange}
            disabled={isSubmitting}
            className="w-full px-3 py-2.5 border border-gray-300 rounded-lg font-poppins transition-all duration-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:cursor-not-allowed text-sm"
          >
            <option value="">Select Location</option>
            <option value={LOCATION_TYPES.SDO}>SDO - Imus City</option>
            <option value={LOCATION_TYPES.SCHOOL}>School - Imus City</option>
          </select>
        </div>

        {/* Department Selection */}
        {formData.locationType === LOCATION_TYPES.SDO && (
          <div className="relative">
            <label htmlFor="department" className="block text-sm font-medium text-gray-700 mb-2 font-poppins">
              Department *
            </label>
            <select
              id="department"
              name="department"
              required
              value={formData.department}
              onChange={handleChange}
              disabled={isSubmitting || locationsLoading}
              className="w-full px-3 py-2.5 border border-gray-300 rounded-lg font-poppins transition-all duration-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:cursor-not-allowed text-sm"
            >
              <option value="">Select Department</option>
              {locationsLoading ? (
                <option disabled>Loading departments...</option>
              ) : locationsError ? (
                <option disabled>Error loading departments</option>
              ) : locations && locations.SDO?.length === 0 ? (
                <option disabled>No departments available</option>
              ) : locations && locations.SDO ? (
                locations.SDO.map((department) => (
                  <option key={department} value={department}>
                    {department}
                  </option>
                ))
              ) : (
                <option disabled>No departments available</option>
              )}
            </select>
          </div>
        )}

        {/* School Level Selection */}
        {formData.locationType === LOCATION_TYPES.SCHOOL && (
          <div className="relative">
            <label htmlFor="schoolLevel" className="block text-sm font-medium text-gray-700 mb-2 font-poppins">
              School Level *
            </label>
            <select
              id="schoolLevel"
              name="schoolLevel"
              required
              value={formData.schoolLevel}
              onChange={handleChange}
              disabled={isSubmitting || locationsLoading}
              className="w-full px-3 py-2.5 border border-gray-300 rounded-lg font-poppins transition-all duration-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:cursor-not-allowed text-sm"
            >
              <option value="">Select School Level</option>
              {locationsLoading ? (
                <option disabled>Loading school levels...</option>
              ) : locationsError ? (
                <option disabled>Error loading school levels</option>
              ) : locations && locations.SCHOOL ? (
                Object.keys(locations.SCHOOL).map((level) => (
                  <option key={level} value={level}>
                    {level}
                  </option>
                ))
              ) : (
                <option disabled>No school levels available</option>
              )}
            </select>
          </div>
        )}

        {/* School Name Selection */}
        {formData.locationType === LOCATION_TYPES.SCHOOL && formData.schoolLevel && (
          <div className="relative">
            <label htmlFor="schoolName" className="block text-sm font-medium text-gray-700 mb-2 font-poppins">
              School Name *
            </label>
            <select
              id="schoolName"
              name="schoolName"
              required
              value={formData.schoolName}
              onChange={handleChange}
              disabled={isSubmitting || locationsLoading}
              className="w-full px-3 py-2.5 border border-gray-300 rounded-lg font-poppins transition-all duration-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:cursor-not-allowed text-sm"
            >
              <option value="">Select School</option>
              {locationsLoading ? (
                <option disabled>Loading schools...</option>
              ) : locationsError ? (
                <option disabled>Error loading schools</option>
              ) : locations && locations.SCHOOL && locations.SCHOOL[formData.schoolLevel]?.length === 0 ? (
                <option disabled>No schools available for this level</option>
              ) : locations && locations.SCHOOL && locations.SCHOOL[formData.schoolLevel] ? (
                locations.SCHOOL[formData.schoolLevel].map((school) => (
                  <option key={school} value={school}>
                    {school}
                  </option>
                ))
              ) : (
                <option disabled>No schools available</option>
              )}
            </select>
          </div>
        )}
      </div>
    </div>
  );
};

export default LocationSection;